// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemTemplateAnomaliesContextQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ItemTemplateAnomaliesContextQuery = { __typename?: 'Query', itemTemplate: { __typename?: 'ItemTemplate', id: string, anomalies: Array<{ __typename?: 'ItemTemplateAnomaly', id: string, type: Types.ItemTemplateAnomalyType, description: string, parent: { __typename?: 'ItemTemplate', id: string, name: string } | { __typename?: 'ItemTemplateItemVersion', id: string, name: string } }> } };

export type ItemTemplateAnomaliesContext_ItemTemplateFragment = { __typename?: 'ItemTemplate', id: string, anomalies: Array<{ __typename?: 'ItemTemplateAnomaly', id: string, type: Types.ItemTemplateAnomalyType, description: string, parent: { __typename?: 'ItemTemplate', id: string, name: string } | { __typename?: 'ItemTemplateItemVersion', id: string, name: string } }> };

export type ItemTemplateAnomaliesContext_ItAnomalyFragment = { __typename?: 'ItemTemplateAnomaly', id: string, type: Types.ItemTemplateAnomalyType, description: string, parent: { __typename?: 'ItemTemplate', id: string, name: string } | { __typename?: 'ItemTemplateItemVersion', id: string, name: string } };

export const ItemTemplateAnomaliesContext_ItAnomalyFragmentDoc = gql`
    fragment ItemTemplateAnomaliesContext_ItAnomaly on ItemTemplateAnomaly {
  id
  type
  description
  parent {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const ItemTemplateAnomaliesContext_ItemTemplateFragmentDoc = gql`
    fragment ItemTemplateAnomaliesContext_ItemTemplate on ItemTemplate {
  id
  anomalies {
    ...ItemTemplateAnomaliesContext_ItAnomaly
  }
}
    ${ItemTemplateAnomaliesContext_ItAnomalyFragmentDoc}`;
export const ItemTemplateAnomaliesContextDocument = gql`
    query ItemTemplateAnomaliesContext($id: ID!) {
  itemTemplate(id: $id) {
    ...ItemTemplateAnomaliesContext_ItemTemplate
  }
}
    ${ItemTemplateAnomaliesContext_ItemTemplateFragmentDoc}`;

/**
 * __useItemTemplateAnomaliesContextQuery__
 *
 * To run a query within a React component, call `useItemTemplateAnomaliesContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplateAnomaliesContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplateAnomaliesContextQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useItemTemplateAnomaliesContextQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemTemplateAnomaliesContextQuery, ItemTemplateAnomaliesContextQueryVariables> & ({ variables: ItemTemplateAnomaliesContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplateAnomaliesContextQuery, ItemTemplateAnomaliesContextQueryVariables>(ItemTemplateAnomaliesContextDocument, options);
      }
export function useItemTemplateAnomaliesContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplateAnomaliesContextQuery, ItemTemplateAnomaliesContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplateAnomaliesContextQuery, ItemTemplateAnomaliesContextQueryVariables>(ItemTemplateAnomaliesContextDocument, options);
        }
export function useItemTemplateAnomaliesContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateAnomaliesContextQuery, ItemTemplateAnomaliesContextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplateAnomaliesContextQuery, ItemTemplateAnomaliesContextQueryVariables>(ItemTemplateAnomaliesContextDocument, options);
        }
export type ItemTemplateAnomaliesContextQueryHookResult = ReturnType<typeof useItemTemplateAnomaliesContextQuery>;
export type ItemTemplateAnomaliesContextLazyQueryHookResult = ReturnType<typeof useItemTemplateAnomaliesContextLazyQuery>;
export type ItemTemplateAnomaliesContextSuspenseQueryHookResult = ReturnType<typeof useItemTemplateAnomaliesContextSuspenseQuery>;
export type ItemTemplateAnomaliesContextQueryResult = Apollo.QueryResult<ItemTemplateAnomaliesContextQuery, ItemTemplateAnomaliesContextQueryVariables>;